import { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const DEFAULTS = {
  lead: '色紙・掛軸・パネル・額装・命名書・ロゴ制作など、各種オーダーメイド作品を承っております。',
  items: [
    { name: '色紙', price: '3,000円〜', lead: '3日〜1週間' },
    { name: '命名書（色紙/奉書）', price: '3,000円〜', lead: '3日〜1週間' },
    { name: 'パネル作品', price: '5,000円〜', lead: '1ヶ月以上' },
    { name: '掛軸', price: '10,000円〜', lead: '1ヶ月以上' },
    { name: '額装作品', price: '30,000円〜', lead: 'ご相談' },
    { name: '社名ロゴ・商用ロゴ等', price: '50,000円〜', lead: 'ご相談' },
  ],
  note: '価格・納期は作品サイズや制作内容により異なります。詳細はお問い合わせください。',
};

function itemsToText(items) {
  return items.map((i) => `${i.name}|${i.price}|${i.lead}`).join('\n');
}

function textToItems(text) {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [name, price, lead] = line.split('|');
      return { name: (name || '').trim(), price: (price || '').trim(), lead: (lead || '').trim() };
    });
}

export default function AdminOrder() {
  const [lead, setLead] = useState(DEFAULTS.lead);
  const [itemsText, setItemsText] = useState(itemsToText(DEFAULTS.items));
  const [note, setNote] = useState(DEFAULTS.note);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState('');

  useEffect(() => {
    getDoc(doc(db, 'siteContent', 'order')).then((snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setLead(data.lead ?? DEFAULTS.lead);
        setItemsText(itemsToText(data.items ?? DEFAULTS.items));
        setNote(data.note ?? DEFAULTS.note);
      }
    });
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus('');
    try {
      await setDoc(doc(db, 'siteContent', 'order'), {
        lead,
        items: textToItems(itemsText),
        note,
      }, { merge: true });
      setStatus('保存しました。');
    } catch (err) {
      setStatus('保存に失敗しました。');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="admin-panel admin-form" onSubmit={onSave}>
      <label className="admin-form__field">
        <span>リード文</span>
        <textarea rows={3} value={lead} onChange={(e) => setLead(e.target.value)} />
      </label>

      <label className="admin-form__field">
        <span>料金表（1行ずつ「品目｜価格｜納期」の形式。例：色紙｜3,000円〜｜3日〜1週間）</span>
        <textarea rows={8} value={itemsText} onChange={(e) => setItemsText(e.target.value)} />
      </label>

      <label className="admin-form__field">
        <span>注記</span>
        <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
      </label>

      <button className="admin-form__submit" type="submit" disabled={saving}>
        {saving ? '保存中...' : '保存する'}
      </button>

      {status && <p className="admin-form__status">{status}</p>}
    </form>
  );
}
